import script from "./uploadModel.vue?vue&type=script&setup=true&lang=jsx"
export * from "./uploadModel.vue?vue&type=script&setup=true&lang=jsx"

const __exports__ = script;

export default __exports__